var React = require('react');

function Flash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.407 0.453125L0.785001 15.0281H4.291L0.753 24.4821L0.625 24.8721L1.343 25.3131L15.033 9.98712H10.27L15.851 0.453125H6.407ZM7.1 11.0171L6.078 13.5801L7.1 13.0881L2.287 13.9981C2.287 13.9981 4.933 15.4721 7.871 12.3431C10.809 9.21412 14.055 1.48312 14.055 1.48312L7.1 12.3431V11.0171Z","fill":"#189DC6"}));
}

Flash.defaultProps = {"width":"16","height":"26","viewBox":"0 0 16 26","fill":"none"};

module.exports = Flash;

Flash.default = Flash;
